enum Currency {
  Eth = 'eth',
  Honey = 'honey',
}

export default Currency;
